/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { createContext } from "react";
import { AuthState, Auth0ContextInterface } from "./types";

/**
 * The initial auth state.
 */
export const initialAuthState: AuthState = {
  isLoading: true,
};

const stub = (): never => {
  throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};

const initialContext = {
  ...initialAuthState,
  checkSession: stub,
  getTokenSilently: stub,
  getIdTokenClaims: stub,
  loginWithRedirect: stub,
  logout: stub,
  handleRedirectCallback: stub,
};

export const Auth0Context =
  createContext<Auth0ContextInterface>(initialContext);
